import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Loader } from "../../components/CustomLoader";
import { userServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";

const ViewTransactionDetail = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await userServices.getByIdTransation({ id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) userData();
  }, [show]);

  return (
    <Dialog open={show} onClose={onHide} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "1.4rem",
          fontWeight: 600,
          pb: 0,
        }}
      >
        Transaction Details
        <IconButton onClick={onHide}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers sx={{ p: 0 }}>
          <Paper elevation={0} sx={{ p: 4 }}>
            <Grid container spacing={4}>
              {/* Left Column */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Transaction Info
                </Typography>
                <Detail label="Transaction ID" value={data?.transaction?.transactionId} />
                <Detail
                  label="Transaction Type"
                  value={capitalize(data?.transaction?.transactionType)}
                />
                <Detail
                  label="Sign Name"
                  value={capitalize(data?.transaction?.signName)}
                />
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Wallet Info
                </Typography>
                <Detail
                  label="Amount"
                  value={`$${data?.transaction?.transactionAmount}`}
                />
                <Detail
                  label="Status"
                  value={capitalize(data?.transaction?.status)}
                />
                <Detail
                  label="Date"
                  value={new Date(data?.transaction?.date).toLocaleString()}
                />
                <Detail
                  label="Wallet Balance"
                  value={`$${data?.walletBalance}`}
                />
                <Detail
                  label="Withdraw Status"
                  value={capitalize(data?.walletWithdrawStatus)}
                />
              </Grid>
            </Grid>

            <DialogActions sx={{ mt: 4, justifyContent: "flex-end" }}>
              <Button variant="contained" onClick={onHide} sx={{ borderRadius: 2 }}>
                Close
              </Button>
            </DialogActions>
          </Paper>
        </DialogContent>
      )}
    </Dialog>
  );
};

const Detail = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontWeight: 500, letterSpacing: 0.5 }}
    >
      {label.toUpperCase()}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      {value || "--"}
    </Typography>
  </Box>
);

export default ViewTransactionDetail;
